module.exports = __webpack_public_path__ + "img/Logout_24.7369d107.svg";